const validate_work_availability = () => {
    var candidate_avaliability = $("#ats_candidate_availability");
    if (candidate_avaliability) {
        if (candidate_avaliability.hasClass("mandatory")) {
            var atLeastOneIsChecked = $(".ats_candidate_availability").find("input:checkbox").is(":checked");
            if (atLeastOneIsChecked && $("#ats_candidate_availability").hasClass("has-error")) {
                $("#ats_candidate_availability").removeClass("has-error");
            } else if (!atLeastOneIsChecked && !$("#ats_candidate_availability").hasClass("has-error")) {
                $("#ats_candidate_availability").addClass("has-error");
            }
        }
    }
}

$(function(){
    $(".manual-apply-button").on("click", function(){
        validate_work_availability();
    });

    $(".ats_candidate_availability").find("input:checkbox").on('change', function(){
        validate_work_availability();
    });

    $("table input:checkbox").on(
        "change",
        function(){
            var checked = $(this).is(":checked");
            var alldays = null;
            var oneday = null;
            var rows = work_availability.days;
            var checkedClass = $(this).attr("class").split(" ");
            var checkedRow = checkedClass[0].split("-")[1];
            var checkedCol = checkedClass[1].split("-")[1];
            for (var i = 0; i < rows.length; i++) {
                var cols = work_availability.days[i].times;
                for (var j = 0; j < cols.length; j++) {
                    if (cols[j].field === $(this).attr("name") && i === 0) {
                        alldays = j;
                    }
                    if (cols[j].field === $(this).attr("name") && j === cols.length-1) {
                        oneday = i;
                    }
                    if (j === alldays) {
                        $("input[name='" + cols[j].field + "']").prop("checked", checked);
                    }
                    if (i === oneday) {
                        $("table").find(".row-" + i).prop("checked", checked);
                    }
                    if ($(this).attr("name") === "all_days") {
                        $("table input:checkbox").prop("checked", checked);
                    }
                    if (["all_mornings", "all_afternoons", "all_evenings", "all_nights"].indexOf($(this).attr("name")) >= 0) {
                        if (checked === false) {
                            $("input[name='all_days']").prop("checked", false);
                            $("table").find(".col-" + cols.length).prop("checked", false);
                        }
                    }
                    if (checked === false) {
                        $("input[class='row-" + checkedRow + " col-" + cols.length + "']").prop("checked", false);
                        $("input[class='row-header col-" + checkedCol + "']").prop("checked", false);
                        $("input[name='all_days']").prop("checked", false);
                    }
                }
            }
        }
    );
});